import { AppBar, Toolbar, Typography, Container, Button, Box, Switch } from "@mui/material";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import api from "./api/api";

function Navbar({ loggedIn, logOut, accountsCount, totalProfit, totalBalance, setMql4Protocol, mql4Protocol }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [appBarHeight, setAppBarHeight] = useState(0);
  const [mobile, setMobile] = useState(0);
  const navigate = useNavigate();

  const updateMql4Protocol = (protocol) => {
    api.updateMQL4Protocol(
      protocol,
      () => {},
      () => {}
    );
  };

  const handleResize = () => {
    if (isMobile && window.screen.orientation.type.includes("portrait")) {
      setMobile(1);
    } else if (isMobile) {
      setMobile(2);
    } else if (window.innerWidth < 800) {
      setMobile(1);
    } else {
      setMobile(0);
    }
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const appBarElement = document.getElementById("TopNavBar");
    if (appBarElement) {
      const height = appBarElement.clientHeight;
      setAppBarHeight(appBarElement);
    }
  }, []);

  function formatNumberWithDots(number) {
    const numberString = number.toString();
    const parts = [];
    for (let i = numberString.length - 1; i >= 0; i -= 3) {
      const part = numberString.substring(Math.max(0, i - 2), i + 1);
      parts.unshift(part);
    }
    return parts.join(".").replace("..", ",");
  }

  const handleTabClick = (tagIndex) => {
    setSelectedTab(tagIndex);
    switch (tagIndex) {
      case 0:
        navigate("/");
        break;
      case 1:
        navigate("/contratos");
        break;
      case 2:
        navigate("/misdatos");
        break;
      default:
        break;
    }
  };

  const styles = {
    tab: {
      cursor: "pointer",
      marginLeft: 10,
    },
  };

  return (
    <AppBar style={{ position: "fixed", background: "#171717" }}>
      <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="/img/icon.png"
            alt="Logo"
            style={{ marginLeft: mobile ? "0" : "10px", cursor: "pointer", height: 40 }}
            onClick={() => (loggedIn ? handleTabClick(0) : window.location.assign("https://taurusargentina.com.ar"))}
          />
          <Box style={{ display: "flex", gap: 15, marginLeft: mobile ? 5 : 20 }}>
            {accountsCount == 0 && (
              <Typography
                style={styles.tab}
                onClick={() =>
                  loggedIn ? handleTabClick(0) : window.location.assign("https://taurusargentina.com.ar")
                }
                fontWeight={selectedTab == 0 ? 600 : 200}
              >
                Inicio
              </Typography>
            )}
          </Box>
        </div>
        {accountsCount > 0 && !totalProfit && (
          <Box style={{ display: "flex", alignItems: "center", marginLeft: mobile ? "15px" : "15px" }}>
            <Typography
              style={{
                fontSize: mobile ? "15px" : "16px",
              }}
              fontWeight={200}
            >
              {mobile ? "Protocolo B" : "Protocolo B"}
            </Typography>
            <Switch
              onClick={() => {
                const newProtocol = mql4Protocol == "A" ? "B" : "A";
                setMql4Protocol(newProtocol);
                updateMql4Protocol(newProtocol);
              }}
              checked={mql4Protocol == "B"}
              label="Protocolo"
            ></Switch>
          </Box>
        )}
        {accountsCount > 0 && (
          <Typography
            style={{
              ...styles.tab,
              cursor: "default",
              marginLeft: "5px",
              textAlign: "center",
              fontSize: mobile ? "15px" : "16px",
            }}
            fontWeight={200}
          >
            Cuentas: {accountsCount}
          </Typography>
        )}

        {loggedIn && totalProfit != null && (
          <Typography
            style={{
              ...styles.tab,
              cursor: "default",
              marginLeft: mobile ? "5px" : "20px",
              marginRight: "5px",
              textAlign: "center",
              fontSize: mobile ? "15px" : "16px",
            }}
            fontWeight={200}
          >
            Profit: ${formatNumberWithDots(totalProfit)}
          </Typography>
        )}
        {loggedIn && totalBalance != null && (
          <Typography
            style={{
              ...styles.tab,
              cursor: "default",
              marginLeft: mobile ? "5px" : "20px",
              marginRight: "5px",
              textAlign: "center",
              fontSize: mobile ? "15px" : "16px",
            }}
            fontWeight={200}
          >
            Balance: ${formatNumberWithDots(totalBalance)}
          </Typography>
        )}
        {loggedIn && !accountsCount && !totalProfit && (
          <>
            <Typography style={styles.tab} onClick={() => handleTabClick(1)} fontWeight={selectedTab == 1 ? 600 : 200}>
              Contratos
            </Typography>
            <Typography style={styles.tab} onClick={() => handleTabClick(2)} fontWeight={selectedTab == 2 ? 600 : 200}>
              Mis datos
            </Typography>
          </>
        )}

        {loggedIn && totalProfit && (
          <Typography
            style={{ ...styles.tab, marginLeft: "auto" }}
            onClick={logOut}
            fontWeight={selectedTab == 3 ? 600 : 200}
          >
            Salir
          </Typography>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
